import { Table } from '@bynder/design-system';
import styled from 'styled-components';

const opacityMap = [1, 0.7, 0.4];
export const StyledSkeletonTableRow = styled(Table.Row)<{ index: number }>`
    opacity: ${(props) => opacityMap[props.index]};
`;
